import React from 'react';
import Icon from '../../../components/AppIcon';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerSections = [
    {
      title: 'Courses',
      links: [
        { name: 'App Development', href: '#courses' },
        { name: 'Machine Learning', href: '#courses' }
      ]
    },
    {
      title: 'Programs',
      links: [
        { name: 'Certificate Internships', href: '#apply-section' },
        { name: 'Industry Mentorship', href: '#mentors' },
        { name: 'Career Guidance', href: '#apply-section' },
        { name: 'Skill Assessment', href: '#apply-section' },
        { name: 'Portfolio Building', href: '#apply-section' }
      ]
    },
    {
      title: 'Company',
      links: [
        { name: 'About Us', href: '#about' },
        { name: 'Our Mission', href: '#about' },
        { name: 'Success Stories', href: '#success-stories' },
        { name: 'Our Team', href: '#mentors' },
        { name: 'Careers', href: '#contact' }
      ]
    },
    {
      title: 'Support',
      links: [
        { name: 'Contact Us', href: '#contact' },
        { name: 'Help Center', href: '#contact' },
        { name: 'Technical Support', href: '#contact' },
        { name: 'Community Forum', href: '#contact' }
      ]
    }
  ];

  const socialLinks = [
    { icon: 'Linkedin', name: 'LinkedIn', url: 'https://www.linkedin.com/company/96950353' },
    { icon: 'Instagram', name: 'Instagram', url: 'https://www.instagram.com/nipixtechnology?igsh=NjM4ZXAyZ3piN21v' }
  ];

  const handleLinkClick = (href) => {
    if (href.startsWith('#')) {
      const element = document.getElementById(href.substring(1));
      if (element) {
        const headerHeight = 80;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerHeight;
        window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
      }
    }
  };

  return (
    <footer className="bg-text-primary text-white">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 space-y-12">
        {/* Top Row - Logo + Info */}
        <div>
          <div className="flex items-center space-x-3 mb-6">
            <div className="w-50 h-20 rounded-lg overflow-hidden flex items-center justify-center shadow-md">
              <img 
                src="/assets/images/only logo.png" 
                alt="Nipix Technology Logo" 
                className="w-full h-full object-contain"
              />
            </div>
            <div>
              <h2 className="text-2xl font-bold">Nipix Technology</h2>
              <p className="text-sm opacity-75">"The Future Technology"</p>
            </div>
          </div>

          <p className="text-gray-300 leading-relaxed mb-6 max-w-full">
            Transforming students into industry-ready professionals through hands-on learning, 
            real projects, and mentorship from top tech companies. Join thousands who have 
            successfully bridged the gap between academic learning and career success.
          </p>

          {/* Contact Info */}
          <div className="space-y-3 mb-6">
            <div className="flex items-center space-x-3">
              <Icon name="MapPin" size={16} className="text-primary" strokeWidth={2} />
              <span className="text-sm text-gray-300">Tambaram, Chennai, Tamil Nadu, India</span>
            </div>
            <div className="flex items-center space-x-3">
              <Icon name="Phone" size={16} className="text-primary" strokeWidth={2} />
              <span className="text-sm text-gray-300">+91 9025608199</span>
            </div>
            <div className="flex items-center space-x-3">
              <Icon name="Mail" size={16} className="text-primary" strokeWidth={2} />
              <span className="text-sm text-gray-300">nipixtech@nipixtechnology.com</span>
            </div>
          </div>

          {/* Social Links */}
          <div className="flex space-x-4">
            {socialLinks.map((social, index) => (
              <a
                key={index}
                href={social.url}
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-primary transition-colors duration-300"
                title={social.name}
              >
                <Icon name={social.icon} size={18} strokeWidth={2} />
              </a>
            ))}
          </div>
        </div>

        {/* Bottom Row - Columns */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-12">
          {footerSections.map((section, index) => (
            <div key={index}>
              <h3 className="text-lg font-semibold mb-4">{section.title}</h3>
              <ul className="space-y-3">
                {section.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <button
                      onClick={() => handleLinkClick(link.href)}
                      className="text-gray-300 hover:text-white transition-colors duration-300 text-sm"
                    >
                      {link.name}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-sm text-gray-400">
              © {currentYear} Nipix Technology. All rights reserved. | 
              <button className="hover:text-white ml-1">Privacy Policy</button> | 
              <button className="hover:text-white ml-1">Terms of Service</button> | 
              <button className="hover:text-white ml-1">Refund Policy</button>
            </div>
            
            <div className="flex items-center space-x-6 text-sm text-gray-400">
              <div className="flex items-center space-x-2">
                <Icon name="Shield" size={16} className="text-success" strokeWidth={2} />
                <span>Secure Platform</span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="Clock" size={16} className="text-primary" strokeWidth={2} />
                <span>24/7 Support</span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="Users" size={16} className="text-secondary" strokeWidth={2} />
                <span>200+ Students</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
